var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c("new-main-header", [_vm._v("\n    Dashboard\n  ")])
        : _c("main-header", [
            _c(
              "span",
              { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "Back to Start Page",
                      placement: "bottom-start",
                    },
                  },
                  [
                    _c("router-link", { attrs: { to: { name: "HomePage" } } }, [
                      _c("i", { staticClass: "el-icon-back" }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { attrs: { slot: "page-title" }, slot: "page-title" }, [
              _vm._v("Dashboard"),
            ]),
          ]),
      _vm._v(" "),
      _c("main-content", [
        _c(
          "div",
          {
            staticClass: "grid gap_m dashboard-page",
            attrs: { slot: "main-content" },
            slot: "main-content",
          },
          [
            _c("new-account-summary"),
            _vm._v(" "),
            _c("device-table", {
              staticClass: "span-12",
              attrs: { "customer-id": _vm.customer.id },
            }),
            _vm._v(" "),
            _c("third-party-devices-table", { staticClass: "span-12" }),
            _vm._v(" "),
            _c("client-devices", {
              staticClass: "span-12 span-12-t",
              attrs: { customer: _vm.customer },
            }),
            _vm._v(" "),
            _c("customer-authorizations", {
              staticClass: "span-12 span-12-t",
              attrs: { customer: _vm.customer },
            }),
            _vm._v(" "),
            _vm.customer.ring_devices
              ? _c("cellular-usage-info", {
                  staticClass: "span-12 span-12-t",
                  attrs: { customer: _vm.customer },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }